class FilterDrawer extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('.filter-drawer-details');
    this.trigger = document.getElementById('ModalFilterTrigger');
    this.overlay = this.querySelector('.modal-overlay');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.trigger.addEventListener('click', this.open.bind(this));    
    this.overlay.addEventListener('click', this.close.bind(this));

    if (this.querySelector('button[type="button"]') !== null) {
      this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
    }    
  }

  open(event) {        
    this.detailsContainer.removeAttribute('hidden');
    this.detailsContainer.classList.add('drawer--active');            
    document.body.classList.add('overflow-hidden');       
    
    const submenus = this.querySelectorAll('.mobile-facets__list');

    submenus.forEach(submenu => {
      // Toggle two-column class based on number of items
      if (submenu.querySelectorAll('li').length > 8) {        
        submenu.classList.add('submenu__two-columns');
      } else {
        submenu.classList.remove('submenu__two-columns');
      }
    
      // Add show more button if more than 16 items
      if (submenu.querySelectorAll('li').length > 16) {
        if (!submenu.querySelector('.show-more-button')) {
          const showMoreBtn = document.createElement('li');
          showMoreBtn.textContent = 'Show More';
          showMoreBtn.classList.add('show-more-button', 'filter-title');
    
          submenu.appendChild(showMoreBtn);
          submenu.classList.add('submenu-collapsible');
          submenu.classList.remove('submenu-opened');
                            
          showMoreBtn.addEventListener('click', function() {
            submenu.classList.toggle('submenu-opened');
            showMoreBtn.textContent = submenu.classList.contains('submenu-opened') 
              ? 'Show Less' 
              : 'Show More';
          });
        }
      }
    });

    if(document.querySelector(".mobile-facets__details[data-filter-type='destinations']")) {
      const filterItem = document.querySelector(".mobile-facets__details[data-filter-type='destinations']");
      // console.log("dddd", filterItem.getAttribute("open"));
      if(filterItem.getAttribute("open") == null) {
        filterItem.querySelector("summary").click();
      }
    }
    
    

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    // const firstFacetDetail = this.querySelector('.mobile-facets__details');
    // if (firstFacetDetail) {
    //   firstFacetDetail.setAttribute('open', '');
    // }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.classList.remove('drawer--active');
    this.detailsContainer.setAttribute('hidden', '');    
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('filter-drawer', FilterDrawer);
